import React, { useState } from "react";
import { CoverSquare } from "../games/CoverImages";
import { useMyGames } from "@seabrookstudios/pitch2table";
import { FilterableGamesList } from "../games/FilterableGamesList";
import { SelectableListEntriesDialog } from "./SelectableListEntriesDialog";
import { ArrowListItem } from "./ArrowListItem";
import { Path } from "../Path";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/types").GameId[]} props.value - Selected game IDs
 * @param {function(import("@seabrookstudios/types").GameId[]): void} props.onChange - Callback when selection changes
 * @param {import("@seabrookstudios/pitch2table-core").DesignerGameStatus[]} props.defaultSelectedStatuses - Default selected statuses
 */
export const SelectGamesDialog = ({ value = [], onChange, defaultSelectedStatuses = ["PitchingNow"] }) => {
  const { data: allGames = [], isLoading } = useMyGames();
  const [selectedGames, setSelectedGames] = useState(value);

  /**
   * @param {import("@seabrookstudios/types").GameId} gameId
   */
  const handleToggleGame = (gameId) => {
    setSelectedGames((current) => {
      if (current.includes(gameId)) {
        return current.filter((id) => id !== gameId);
      }
      return [...current, gameId];
    });
  };

  const handleSave = () => {
    onChange(selectedGames);
  };

  const OnAddOverlay = (
    <FilterableGamesList
      games={allGames}
      selectedGames={selectedGames}
      onToggleGame={handleToggleGame}
      defaultSelectedStatuses={defaultSelectedStatuses}
    />
  );

  const selectedGameObjects = allGames.filter((game) => selectedGames.includes(game.id));
  return (
    <SelectableListEntriesDialog
      title="Linked Games"
      OnAddOverlay={OnAddOverlay}
      isLoading={isLoading}
      handleSave={handleSave}
    >
      {selectedGameObjects.map((game) => (
        <ArrowListItem
          key={game.id}
          to={Path.game(game.id).link()}
          primary={game.name}
          secondary={game.tag}
          Left={() => <CoverSquare game={game} width={48} height={48} />}
        />
      ))}
    </SelectableListEntriesDialog>
  );
};
